import { on } from '../utils/_fn';
import Tooltip from 'bootstrap/js/dist/tooltip';

/**
 * 初始化密碼顯示/隱藏切換功能
 *
 * @description
 * 使用單一按鈕切換密碼顯示/隱藏，同時更新圖示和 tooltip 文字。
 *
 * @example
 * HTML 結構（配合 _form.pug 的 formPassword mixin）：
 * ```html
 * <div class="input-group form-field__password-wrap">
 *   <input type="password" id="password" />
 *   <button type="button" class="js-password-toggle" data-password-target="password">
 *     <i class="be-icon be-icon-show"></i>
 *     <i class="be-icon be-icon-hide d-none"></i>
 *   </button>
 * </div>
 * ```
 *
 * 屬性說明：
 * - data-password-target: 目標 input 的 id
 * - .js-password-toggle: 切換按鈕
 * - 按鈕內需有 .be-icon-show 和 .be-icon-hide 兩個圖示元素
 * - 使用 Bootstrap 的 d-none class 控制圖示顯示
 */
export function initTogglePasswordVisibility() {
  const toggleButtons = document.querySelectorAll('.js-password-toggle');

  if (!toggleButtons.length) return;

  toggleButtons.forEach((button) => {
    const targetId = button.getAttribute('data-password-target');
    if (!targetId) return;

    const input = document.getElementById(targetId);
    if (!input) return;

    // 取得按鈕內的顯示/隱藏圖示
    const showIcon = button.querySelector('.be-icon-show');
    const hideIcon = button.querySelector('.be-icon-hide');

    on(button, 'click', () => {
      // 判斷目前密碼是否可見
      const isVisible = input.type === 'text';

      // 切換 input type
      input.type = isVisible ? 'password' : 'text';

      // 切換圖示顯示狀態
      if (showIcon && hideIcon) {
        showIcon.classList.toggle('d-none', !isVisible);
        hideIcon.classList.toggle('d-none', isVisible);
      }

      // 更新無障礙標籤
      const label = isVisible ? '顯示密碼' : '隱藏密碼';
      button.setAttribute('aria-label', label);

      // 更新 Bootstrap tooltip 文字
      // 使用與初始化相同的 Tooltip import，確保 getInstance 能正確取得實例
      const tooltipInstance = Tooltip.getInstance(button);

      if (tooltipInstance) {
        // 先隱藏，防止位置計算出錯
        tooltipInstance.hide();
        // 更新 data 屬性與 tooltip 內容
        button.setAttribute('data-bs-title', label);
        tooltipInstance.setContent({ '.tooltip-inner': label });
        // 重新定位
        tooltipInstance.update();
      }
    });
  });
}
